// typewriter — folha de papel levemente inclinada (ScriptGraphic do edvid) com a frase
// sendo digitada e um cursor na cor de destaque. O texto inteiro já ocupa o lugar
// (o resto fica transparente), então as linhas não pulam enquanto digita.
import React from 'react';
import type { TypewriterProps } from './schema';
import { EASE_OUT, FONT, SAFE_W, fitFont, inkAccent, prog, useGFrame, type GraphicComponentProps } from './common';

const W = SAFE_W - 60;
const PAD = 50;

export const Typewriter: React.FC<GraphicComponentProps<TypewriterProps>> = ({ props, totalFrames, accent }) => {
  const f = useGFrame();
  const text = props.text;
  const ink = inkAccent(accent);
  const start = 8;
  const typeEnd = Math.max(start + 8, Math.round(totalFrames * 0.66));
  const cps = Math.max(1.1, text.length / (typeEnd - start)); // caracteres por quadro
  const shownN = Math.max(0, Math.min(text.length, Math.floor((f - start) * cps)));
  const typing = shownN < text.length;
  const cursorOn = typing || Math.floor(f / 8) % 2 === 0;
  // tamanho: frases curtas grandes, longas até ~4 linhas
  const size = text.length <= 28 ? fitFont(text, { weight: 700, max: 58, min: 44, maxWidth: W - PAD * 2 }) : text.length <= 60 ? 46 : 40;
  const titleIn = prog(f, 2, 9, EASE_OUT);

  return (
    <div
      style={{
        width: W,
        borderRadius: 18,
        background: 'linear-gradient(180deg,#f7f4ec 0%,#efeadd 100%)',
        boxShadow: '0 22px 55px rgba(0,0,0,0.5)',
        rotate: '-2deg',
        padding: `${props.title ? 40 : 46}px ${PAD}px 48px`,
        boxSizing: 'border-box',
        fontFamily: FONT,
        position: 'relative',
      }}
    >
      {props.title ? (
        <div style={{ opacity: titleIn, marginBottom: 26 }}>
          <div style={{ fontWeight: 900, fontSize: 26, letterSpacing: 3, color: ink, textTransform: 'uppercase' }}>{props.title}</div>
          <div style={{ height: 4, width: 90 * titleIn, background: ink, borderRadius: 3, marginTop: 10 }} />
        </div>
      ) : null}
      <div style={{ fontWeight: 600, fontSize: size, lineHeight: 1.36, color: '#26262b', letterSpacing: -0.3, overflowWrap: 'break-word' }}>
        <span>{text.slice(0, shownN)}</span>
        <span
          style={{
            display: 'inline-block',
            width: Math.max(4, Math.round(size * 0.09)),
            height: size * 1.02,
            marginLeft: 3,
            marginRight: -3 - Math.max(4, Math.round(size * 0.09)),
            verticalAlign: '-0.14em',
            background: ink,
            borderRadius: 2,
            opacity: cursorOn ? 1 : 0,
          }}
        />
        <span style={{ color: 'transparent' }}>{text.slice(shownN)}</span>
      </div>
    </div>
  );
};
